const palette = {
  primary: {
    dark: '#BB001E',
    main: '#DF0024',
    medium: '#E63350',
    light: '#EC667C',
    lighter: '#F299A7',
    lightest: '#F9CCD3',
    lightestPlus: '#FEF9FA',
  },
  // secondary: {
  //   dark: '#',
  //   main: '#',
  //   medium: '#',
  //   light: '#',
  //   lighter: '#',
  // },
  neutral: {
    black: '#000000',
    dark: '#333333',
    main: '#666666',
    light: '#999999',
    lighter: '#CCCCCC',
    lightest: '#F9F9F9',
    white: '#FFFFFF',
  },
  purple: {
    dark: '#821E82',
    main: '#9B4B9B',
    medium: '#B478B4',
    light: '#CDA5CD',
    lighter: '#E6D2E6',
  },
  turquoise: {
    darkest: '#1F6D66',
    dark: '#00BEB4',
    main: '#33CBC3',
    medium: '#66D8D2',
    light: '#99E5E1',
    lighter: '#CCF2F0',
  },
  green: {
    darkest: '#526C0C',
    dark: '#B4D246',
    main: '#C3DB6B',
    medium: '#D2E490',
    light: '#E1EDB5',
    lighter: '#F0F6DA',
  },
  yellow: {
    darkest: '#865000',
    dark: '#FFEB00',
    main: '#FFEF33',
    medium: '#FFF366',
    light: '#FFF799',
    lighter: '#FFFBCC',
    lightest: '#FEFEF4',
  },
  orange: {
    darkest: '#A66C00',
    dark: '#E59500',
    main: '#FFB62E',
    medium: '#FFC75C',
    light: '#FFD88A',
    lighter: '#FFE7B9',
    lightest: '#FFF2D9',
  },
  success: {
    darkest: '#526C0C',
    dark: '#B4D246',
    main: '#D2E490',
    light: '#F0F6DA',
  },
  warning: {
    darkest: '#865000',
    dark: '#FFEB00',
    main: '#FFF366',
    light: '#FFFBCC',
  },
  error: {
    dark: '#DF0024',
    main: '#EC667C',
    light: '#FDF1F3',
  },
  info: {
    darkest: '#1F6D66',
    dark: '#00BEB4',
    main: '#66D8D2',
    light: '#EFFBFA',
  },
}

export default palette
